module.exports = {"510524100":"叙永镇","510524101":"江门镇","510524102":"马岭镇","510524103":"天池镇","510524104":"水尾镇","510524105":"两河镇","510524106":"落卜镇","510524107":"后山镇","510524108":"分水镇","510524109":"摩尼镇","510524110":"赤水镇","510524111":"龙凤镇","510524112":"正东镇","510524113":"观兴镇","510524114":"向林镇","510524115":"兴隆镇","510524116":"营山镇","510524117":"麻城镇","510524118":"大石镇","510524119":"黄坭镇","510524210":"合乐苗族乡","510524211":"白腊苗族乡","510524212":"枧槽苗族乡","510524213":"水潦彝族乡","510524215":"石厢子彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510524.json
// module id = 2291
// module chunks = 0